import React, { useEffect, useState } from "react";
import "./index.less";
import LabStatusesTable from "./activityTypesTable";
import { useSelector } from "react-redux";

const LabStatuses = () => {
  const { user } = useSelector((state) => state.authReducer);
  const [canUpdate, setCanUpdate] = useState(false);

  useEffect(() => {
    if (user?.permissions?.lab_statuses?.add_edit) {
      setCanUpdate(true);
    }
  }, [user]);

  return (
    <div className="page-top-div">
      <span className="text-span">Lab Statuses</span>
      <LabStatusesTable canUpdate={canUpdate} />
    </div>
  );
};

export default LabStatuses;
